import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

const useTrackAddressEvent = () => {
  const isWebEngageEnabled = useFeatureFlag("webEngage");
  const trackAddressEvent = useCallback(
    (addressDetails, isEdit) => {
      if (!isWebEngageEnabled) {
        console.warn("WebEngage feature is disabled");
        return;
      }
      if (window.webengage) {
        if (addressDetails) {
          const {
            street,
            city,
            zipCode,
            firstName,
            lastName,
            phoneNumber,
            email,
            line1,
            country,
            title,
            defaultAddress,
          } = addressDetails;
          const eventData = {
            firstName,
            lastName,
            zipCode,
            country,
            phoneNumber,
            city,
            street,
            title,
            email,
            line1,
            defaultAddress,
          };

          window.webengage.track(
            isEdit ? "address_updated" : "add_new_address",
            eventData
          );
        }
      } else {
        console.error("WebEngage is not defined");
      }
    },
    [isWebEngageEnabled]
  );

  return { trackAddressEvent };
};

export default useTrackAddressEvent;
